import { h, Component } from 'preact';
import Store from 'store/store';
import { startLogin } from 'helpers/credentials';
import { commaSeparatedList, joinClasses } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import getCopyWithParams from 'utils/getCopyWithParams';
import { getShowtimesData } from 'utils/bolt/index';
import OverlayBackButton from 'components/bolt/overlayBackButton/overlayBackButton';
import HTML from 'components/core/html/html';
import CountryDropdown from 'components/bolt/login/countryDropdown';

import s from 'components/bolt/login/login.sss';

function getClickedRegion() {
	const showtimesData = Store.get()?.showtimes;
	const screening = showtimesData?.desiredScreen;
	if (!/^\w+(-\w+){4}$/.test(screening)) {
		return null;
	}
	const theater = showtimesData.data?.find(th => th.screenings?.some(s => s.id === screening));
	return theater?.address?.intl?.country?.toLowerCase();
}
function getGeoRegion() {
	return Store.get()?.client?.geo?.countryCode?.toLowerCase();
}

export default class Login extends Component {
	constructor(props) {
		super(props);

		const queryString = parseQueryString();
		this.fromTwitter = queryString['x-redirect'];
		this.isWebview = props.client?.isSocialWebview;

		this.availableRegions = this.getAllowedRegions();

		this.state = {
			region: this.getRequestedRegion(props),
		};

		this.onLogin = this.onLogin.bind(this);
		this.onSelectRegion = this.onSelectRegion.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const showNext = nextProps.showtimesStore?.showLoginScreen;
		if (showNext && !this.props.showtimesStore?.showLoginScreen) {
			this.setState({ region: this.getRequestedRegion(nextProps) });
		}
	}

	getAllowedRegions() {
		const regions = commaSeparatedList(getShowtimesData()?.primePremiere?.membershipCountries?.toLowerCase());
		if (!regions.length) {
			return [__REGION__];
		}
		return regions.sort();
	}

	getRequestedRegion() {
		const ifAllowed = r => this.availableRegions.includes(r) && r;
		return ifAllowed(getClickedRegion()) || ifAllowed(getGeoRegion()) || ifAllowed(__REGION__) || this.availableRegions[0] || 'us';
	}

	onBackClick() {
		Store.emit('SHOW_LOGIN_SCREEN', { show: false });
		Store.emit('RESET_DESIRED_SCREEN');
	}

	onLogin() {
		startLogin(this.state.region);
	}

	onStartHereClick() {
		Store.emit('TRACK_GET_PRIME');
	}

	onSelectRegion(e) {
		const region = e.target.value;
		this.setState({ region });
		Store.emit('TRACK_PRIME_REGION_SELECT', e.target.value);
	}

	renderLogin() {
		const regions = this.availableRegions;
		const button = (
			<button class={s.btn} onClick={this.onLogin} key="button">
				<img class={s.loginWithAmazon} src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png" alt="Login with Amazon" />
			</button>
		);
		if (regions.length <= 1) {
			return button;
		}
		const regionHelpText = this.props.appData?.copy?.baseCopy?.$PRIME_REGION_SELECT_TEXT;
		return [
			<HTML class={s.regionText} content={regionHelpText} markdown key="context" />,
			<CountryDropdown
				class={s.regionDropdown}
				options={regions}
				value={this.state.region}
				onChange={this.onSelectRegion}
				client={this.props.client}
			/>,
			button
		];
	}

	render(props) {
		const { showtimesStore, appData, client } = props;
		const show = showtimesStore?.showLoginScreen;
		const hasPrimeBlock = showtimesStore?.showPrimeBlock;
		const imageRoot = appData?.urls?.roots?.image || '';
		const copy = appData?.copy?.baseCopy || {};
		// const releaseDay = appData?.meta?.dates?.release;
		// const dayOfWeek = new Date(`${releaseDay}T00:00:00Z`).toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });

		const text = getCopyWithParams(copy, '$BANNER_TEXT');

		const primePremiereData = getShowtimesData()?.primePremiere || {};
		const signUpLink = primePremiereData.signUpLink || 'https://www.amazon.com/amazonprime';
		const showWebviewPrompt = this.isWebview || !!this.fromTwitter;

		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<OverlayBackButton
					ariaLabel="back"
					onClick={this.onBackClick}
					client={client}
				/>
				<div class={s.content}>
					<img class={s.logo} src={`${imageRoot}/prime_premiere.png`} alt="logo" key="logo" />
					{/* <HTML class={s.text} content={text} markdown key="text" /> */}
					<p class={s.text}>{copy.$BANNER_TEXT}</p>
					<p class={s.date}>{copy.$EVENT_DATE}</p>
					{showWebviewPrompt && <p class={s.twitterXRedirect} key="twitter-redir">{copy.$TWITTER_REDIRECT_TEXT}</p>}
					<hr />
					{!!hasPrimeBlock && <p class={s.primeBlock} key="prime-block">{copy.$PRIME_BLOCK}</p>}
					{this.renderLogin()}
					<hr />
					<p class={s.newCustomer} key="new-customer">
						<span>{copy.$NEW_CUSTOMER}</span>
						<a class={s.startHere} href={signUpLink} target="_blank" onClick={this.onStartHereClick}>{copy.$START_HERE}</a>
					</p>
				</div>
			</div>
		);
	}
}